import { calculateBasketCount } from "@shared/utils.basket";
import { useBasket } from "./useBasket";

export function useBasketCount(): number {
  const basket = useBasket();
  return calculateBasketCount(basket);
}
